(() => {
  'use strict';

  const MATCH_TEXT = [
    /\$[\d,.]+\s*OFF your order/i,
    /Apply discount and go to checkout/i,
    /You got\s*\$?[\d,.]+\s*OFF/i,
    /abandoned\s*cart/i
  ];

  const SAFE_ALLOW = [
    'cart-notification',
    'cart-drawer',
    'shopify-section-header',
    'MainContent',
    'CartDrawer',
    'cart-errors',
    'cart-live-region-text'
  ];

  function textMatches(node) {
    const text = (node && node.innerText) || (node && node.textContent) || '';
    if (!text || text.length < 12) return false;
    return MATCH_TEXT.some((pattern) => pattern.test(text));
  }

  function isProtected(node) {
    if (!(node instanceof Element)) return true;
    return SAFE_ALLOW.some((id) => node.id === id || node.closest(`#${CSS.escape(id)}`));
  }

  function likelyPopupRoot(node) {
    if (!(node instanceof Element)) return null;
    if (isProtected(node)) return null;

    const candidates = [];
    let current = node;
    for (let i = 0; current && i < 8; i += 1, current = current.parentElement) {
      if (isProtected(current)) break;
      const styles = window.getComputedStyle(current);
      const rect = current.getBoundingClientRect();
      const z = Number.parseInt(styles.zIndex || '0', 10) || 0;
      const fixedish = styles.position === 'fixed' || styles.position === 'sticky' || styles.position === 'absolute';
      const largeEnough = rect.width > 240 && rect.height > 160;
      const overlayish = z >= 20 || fixedish;
      if (largeEnough && overlayish) candidates.push(current);
    }

    return candidates[0] || node.closest('[role="dialog"], [aria-modal="true"], .modal, .popup, [class*="popup"], [class*="modal"], [id*="popup"], [id*="modal"]') || null;
  }

  function suppress(root = document.body) {
    if (!root) return 0;
    const scanRoot = root instanceof Element ? root : document.body;
    const nodes = [scanRoot, ...scanRoot.querySelectorAll('body *')];
    let removed = 0;

    for (const node of nodes) {
      if (!textMatches(node)) continue;
      const popup = likelyPopupRoot(node);
      if (!popup || isProtected(popup)) continue;
      popup.setAttribute('data-pp-suppressed-abandoned-cart-popup', 'true');
      popup.remove();
      removed += 1;
    }

    // Some apps add a separate dark/transparent overlay sibling.
    if (removed) {
      document.querySelectorAll('[class*="overlay"], [class*="backdrop"], [id*="overlay"], [id*="backdrop"]').forEach((node) => {
        if (!(node instanceof Element) || isProtected(node)) return;
        const styles = window.getComputedStyle(node);
        const z = Number.parseInt(styles.zIndex || '0', 10) || 0;
        if ((styles.position === 'fixed' || styles.position === 'absolute') && z >= 20) {
          node.remove();
        }
      });
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    return removed;
  }

  function scheduleSuppress(root) {
    requestAnimationFrame(() => suppress(root));
    setTimeout(() => suppress(root), 250);
    setTimeout(() => suppress(root), 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleSuppress(document.body), { once: true });
  } else {
    scheduleSuppress(document.body);
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof Element && textMatches(node)) {
          scheduleSuppress(node);
          continue;
        }
        if (node instanceof Element && node.querySelector && [...node.querySelectorAll('*')].some(textMatches)) {
          scheduleSuppress(node);
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.PP_SUPPRESS_ABANDONED_CART_POPUP = { suppress };
})();
